import { useEffect, useRef } from 'react';
import { useAtomValue } from 'jotai';
import { firstSelectedAnnotationIdAtom } from '../../../../../labelling-v2/atoms/tool-atoms';
import { FRAME_HEIGHT } from './constants';
type PropsT = {
  gridContainer: HTMLDivElement | null;
  annotationObjectIds: string[];
};
export function ScrollSelectedAnnotationInView({
  gridContainer,
  annotationObjectIds
}: PropsT) {
  const firstSelectedAnnotationId = useAtomValue(firstSelectedAnnotationIdAtom);
  const annotationObjectIdsRef = useRef(annotationObjectIds);
  annotationObjectIdsRef.current = annotationObjectIds;
  useEffect(() => {
    if (!firstSelectedAnnotationId) {
      return;
    }
    if (!gridContainer) {
      return;
    }

    // columnIndex sync is not required because CurrentFrameMarker component
    // already handles this. We only need to scroll row if it's not available in
    // the current grid's viewport.

    const rowIndex = annotationObjectIdsRef.current.indexOf(firstSelectedAnnotationId);
    if (rowIndex === -1) {
      return;
    }
    const rowStart = rowIndex * FRAME_HEIGHT;
    const rowEnd = rowStart + FRAME_HEIGHT;
    const currentScrollTop = gridContainer.scrollTop;
    const containerHeight = gridContainer.clientHeight;
    const containerTop = currentScrollTop;
    const containerBottom = containerTop + containerHeight;
    if (rowStart >= containerTop && rowStart <= containerBottom && rowEnd >= containerTop && rowEnd <= containerBottom) {
      return;
    }
    const scrollDirection = currentScrollTop > rowStart ? 'up' : 'down';
    const maxScrollTop = gridContainer.scrollHeight - containerHeight;

    // eslint-disable-next-line react-hooks/immutability
    gridContainer.scrollTop = scrollDirection === 'down' ? Math.min(maxScrollTop, rowStart) : Math.max(0, rowStart);
  }, [firstSelectedAnnotationId, gridContainer]);
  return null;
}